import { FC } from 'react'
import { Markdown } from '~shared'

import styles from './DescBlock.module.scss'

type DescBlock = {
  title: string
  description: string
  key: string
}

const DescBlock: FC<{ articles: Array<DescBlock>; withoutAbout?: boolean }> = ({
  articles,
  withoutAbout,
}) => (
  <section className={`${styles['info-section-container']}`}>
    {articles.map(({ title, description, key }) => (
      <div key={key}>
        <h3>{title}</h3>
        <Markdown variant="standart" md={description} />
      </div>
    ))}
    {!withoutAbout && (
      <article>
        <h3>About Granted</h3>
        <p>
          We are an experience platform dedicated to creating deeper, more meaningful connections
          between artists and fans. And we care a lot about that first sentence. Like A LOT. Because
          we’re just fans—like you. At Granted, you can purchase VIP packages curated by your
          favorite artists, bid on unforgettable auctions that benefit important causes, and get
          tickets to awesome live events. <br /> <br />
          Look, we know we aren’t the first and we know the purchase to delivery process can have
          its ‘ WTF’ moments. So we came together and created Granted. But here, we will always have
          your back to ensure you have the best experience when going with Granted. So what are you
          waiting for? <br />
          <br />
          Let’s get your access, Granted.
          {/* Because general admission has never been exciting enough. Because a livestream has never
          felt close enough. Because every experience leaves you wanting more.
          <br />
          <br /> It’s time to get your access Granted.
          <br /> <br />
          Welcome to a brand new platform designed to give you the VIP access you deserve to some of
          the most in-demand events and tours the world has to offer. From exclusive tours and
          events to unbelievable once in a lifetime auctions, your world is about to be unlocked in
          a way you never thought possible. */}
        </p>
      </article>
    )}
  </section>
)

export default DescBlock
